/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Syphon from 'backbone.syphon';
import { View } from 'backbone.marionette';

import tmplInputView from './InputView.hbs';

const InputView = View.extend({
  template: tmplInputView,

  ui: {
    removeInput: 'button.remove-input',
    input: 'input'
  },

  triggers: {
    'click @ui.removeInput': 'remove:input'
  },

  initialize(options) {
    this.inputName = this.options.inputName;
  },

  templateContext() {
    return this.options;
  },

  onRender() {
    this.ui.input.val(this.model.get(this.inputName));
  },

  getFormData() {
    return Syphon.serialize(this);
  }
});

export default InputView;
